import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, Button, Space } from 'antd';
import { OrganizationContext } from '../../../Services/OrganizationContext';
import authService from '../../../Services/authService';
import { useParams } from "react-router";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { usePermissions } from '../../../Services/PermissionsContext';
import { hasPermission } from '../../../Services/checkPermissions';

const Refund = () => {
  const permissions = usePermissions();
  const navigate = useNavigate();
  const { organization } = useContext(OrganizationContext);
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({ search: '' });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    if (organization) {
      loadRefund(currentPage, pageSize);
    }
  }, [organization, currentPage, pageSize]);

  const handlePageChange = (page, newPageSize) => {
    setCurrentPage(page);
    setPageSize(newPageSize);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const loadRefund = (page = 1, perPage = pageSize) => {
    const token = authService.getCurrentadmin().token;
    const url = new URL(authService.getApiUrl() + 'refundlist');

    fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        organization_id: organization,
        page,
        per_page: perPage,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (res.status === 401) {
          authService.logout();
          window.location.href = "/admin";
        } else {
          return res.json();
        }
      })
      .then((result) => {
        setData(result.data.data || []);
        setTotalRecords(result.data.total || 0);
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const token = authService.getCurrentadmin().token;

    fetch(authService.getApiUrl() + 'refundsearch', {
      method: 'POST',
      body: JSON.stringify({
        search: formData.search,
        user_id: authService.getCurrentadmin().UserInfo.id,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setData(result.data.data || []);
        setTotalRecords(result.data.total || 0);
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  const updateOrderStatus = (record) => {
    const token = authService.getCurrentadmin().token;

    fetch(authService.getApiUrl() + 'refundinitiate/' + record.id, {
      method: 'PUT',
      body: JSON.stringify({
        order_status_id: record.order_status_id == 6 ? 7 : null,
        lab_order_status_id: record.lab_order_status_id == 6 ? 7 : null,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then(() => {
        loadRefund(currentPage, pageSize);
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  const columns = [
    {
      title: "Transaction ID",
      dataIndex: "transaction_id",
      render: (text) => <span>{text || '-'}</span>,
      sorter: (a, b) => (a.transaction_id || '').localeCompare(b.transaction_id || ''),
    },
    {
      title: "Invoice Number",
      dataIndex: "invoice_number",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => (a.invoice_number || '').localeCompare(b.invoice_number || ''),
    },
    {
      title: "User Name",
      dataIndex: "user_name",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => (a.user_name || '').localeCompare(b.user_name || ''),
    },
    {
      title: "Refund Amount",
      dataIndex: "final_price",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => parseFloat(a.final_price) - parseFloat(b.final_price),
    },
    {
      title: "Date Time",
      dataIndex: "date_time",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => parseFloat(a.date_time) - parseFloat(b.date_time),
    },
    {
      title: 'Status',
      key: 'status',
      render: (_, record) => {
        const showRefundButton =
          record.lab_order_status_id === 6 ||
          record.order_status_id === 6;
        const statusText = record.home_order_status || record.lab_order_status || 'N/A';
        //const isApproved = statusText.toLowerCase().includes('success');
        return (
          <span className={showRefundButton ? 'status-btn-red' : 'status-btn-green'}>
            {statusText}
          </span>
        );
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => {
        const showRefundButton =
          record.lab_order_status_id === 6 ||
          record.order_status_id === 6;

        return (
          <Space size="middle">
            {showRefundButton && (
              <span
                className='status-btn-green'
                style={{ whiteSpace: 'nowrap', cursor: 'pointer' }}
                onClick={() => updateOrderStatus(record)}
              >
                Initiate Refund
              </span>
            )}
          </Space>
        );
      },
    },
  ];

  return (
    <div className='main-container'>
      <div className='container-fluid'>
        <Breadcrumb />
        <div className='category-table'>
          <div className='flex-cont add-cat'>
            <div className='heading'>
              <h3>Refund</h3>
            </div>
          </div>
          <div className='flex-cont just-cont-left bord-botm'>
            <div className='filter-search'>
              <input
                type='text'
                className='category-search'
                placeholder='Search by date'
                onChange={handleInputChange}
                name="search"
                id="search"
              />
              <Button type='submit' onClick={handleSubmit}>Search</Button>
            </div>
          </div>
          <div className='hospitals-table' id='hospitals_table'>
            <Table
              dataSource={data}
              columns={columns}
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: totalRecords,
                onChange: handlePageChange,
              }}
              rowKey={(record) => record.id}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Refund;
